<script setup lang="ts">
import { withCustomTheme } from "@/composables/withCustomTheme";
import { provideNavContents, provideTopBarContents } from "@/dokos-ui";
import { createToast } from "@/utils";
import { Toasts } from "frappe-ui";
import { onMounted } from "vue";
import BSidebarContents from "./components/BSidebarContents.vue";
import BTopBarContents from "./components/BTopBarContents.vue";

onMounted(async () => {
  window.addEventListener("online", () => {
    createToast({
      title: "You are now online",
      icon: "wifi",
      iconClasses: "stroke-green-600",
    });
  });

  window.addEventListener("offline", () => {
    createToast({
      title: "You are now offline",
      icon: "wifi-off",
      iconClasses: "stroke-red-600",
    });
  });
});

withCustomTheme();

provideNavContents(BSidebarContents);
provideTopBarContents(BTopBarContents);
</script>

<template>
  <RouterView class="antialiased" />
  <Toasts />

  <link rel="preconnect" href="https://fonts.googleapis.com" />
  <link
    rel="preconnect"
    href="https://fonts.gstatic.com"
    crossorigin="anonymous"
  />
</template>

<style>
.b-outline {
  @apply focus-within:outline outline-2 outline-blue-500 outline-offset-2;
}

.text-primary {
  color: var(--theme-primary, #37f);
}
.text-primary-dark {
  color: var(--theme-primary-dark, #23c);
}
.text-primary-light {
  color: var(--theme-primary-light, #4bf);
}

.bg-primary {
  background-color: var(--theme-primary, #37f);
}
.bg-primary-dark {
  background-color: var(--theme-primary-dark, #23c);
}
.bg-primary-light {
  background-color: var(--theme-primary-light, #4bf);
}

.ql-editor h1 {
  @apply text-3xl font-extrabold leading-normal;
}
.ql-editor h2 {
  @apply text-2xl font-extrabold leading-normal;
}
.ql-editor h3 {
  @apply text-xl font-extrabold leading-normal;
}
.ql-editor p {
  @apply py-2;
}
</style>
